var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { BehaviorSubject } from 'rxjs';
import { throttleTime, skip, takeUntil } from 'rxjs/operators';
import { FormBaseElement, XbpmActionType } from '@unitarius/xbpm-runtime';
import { mapElementClass, omitSpecialProperties } from '../../common/utils/element.utils';
import { Button } from 'primereact/button';
import { ControlError } from './ControlError';
var CLICK_THROTTLE_TIME = 300;
var ButtonControl = /** @class */ (function (_super) {
    __extends(ButtonControl, _super);
    function ButtonControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._click$ = new BehaviorSubject(null);
        _this._enterPress$ = new BehaviorSubject(null);
        _this.click$ = _this._click$.pipe(skip(1), throttleTime(CLICK_THROTTLE_TIME), takeUntil(_this.destroy$));
        _this.enterPress$ = _this._enterPress$.pipe(skip(1), throttleTime(CLICK_THROTTLE_TIME), takeUntil(_this.destroy$));
        _this.btnRef = undefined;
        _this.handleEnterPress = function (evt) {
            var _a = _this.state.def, label = _a.label, frontOptions = _a.frontOptions;
            if (evt.key === 'Enter') {
                console.warn("Triggered button click on \"ENTER\" with label: " + (label || frontOptions.label));
                _this.btnRef.click();
            }
        };
        _this.onClick = function (evt) {
            evt.preventDefault();
            evt.stopPropagation();
            _this._click$.next(evt);
        };
        return _this;
    }
    ButtonControl.prototype.componentDidMount = function () {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        this.click$.subscribe(function () {
            var target = _this.state.def;
            var type = target.actionButton || XbpmActionType.FRONT_CLICK;
            if (type) {
                _this.props.onEvent({ type: type, target: target });
            }
        });
        var frontOptions = this.state.def.frontOptions;
        var triggerOnEnter = frontOptions.triggerOnEnter;
        if (triggerOnEnter) {
            document.addEventListener('keyup', this.handleEnterPress);
        }
    };
    ButtonControl.prototype.componentWillUnmount = function () {
        document.removeEventListener('keyup', this.handleEnterPress);
    };
    ButtonControl.prototype.elementRender = function (def) {
        var _this = this;
        var frontOptions = def.frontOptions, id = def.id, disabled = def.disabled;
        var severity = frontOptions.severity, modalFormCode = frontOptions.modalFormCode, templateBlockCode = frontOptions.templateBlockCode, validationBlockCode = frontOptions.validationBlockCode, isIgnoreValidation = frontOptions.isIgnoreValidation, className = frontOptions.className, label = frontOptions.label, restOptions = __rest(frontOptions, ["severity", "modalFormCode", "templateBlockCode", "validationBlockCode", "isIgnoreValidation", "className", "label"]);
        return def.hidden ? null : (React.createElement("div", { className: mapElementClass(frontOptions) },
            React.createElement(Button, __assign({ key: id, id: id, label: label || def.label, type: "button" }, omitSpecialProperties(restOptions), { ref: function (ref) {
                    if (ref) {
                        _this.btnRef = ref['element'];
                        ref['element'].setAttribute('field-code', def.code);
                    }
                }, className: [severity, className].join(' '), disabled: disabled, tooltip: frontOptions.hint, onClick: this.onClick })),
            React.createElement(ControlError, { error: this.error, touched: this.touched })));
    };
    return ButtonControl;
}(FormBaseElement));
export { ButtonControl };
//# sourceMappingURL=Button.js.map